import React, { useState, useEffect } from 'react';
import useResponsive from 'hooks/useResponsive';
import { withAuctionCore } from 'agent';
import { formatNumberWithCommas } from 'components/helpers';
import PropTypes from 'prop-types';
import Filters from './Filters';
import {
  Container, AttributesTable, Table, Td, Tr, TableTitle, SectionWrapper, VGPlusLink,
} from './styles';
import useStores from '../../hooks/useStore';

const Months = {
  1: 'Jan',
  2: 'Feb',
  3: 'Mar',
  4: 'Apr',
  5: 'May',
  6: 'Jun',
  7: 'Jul',
  8: 'Aug',
  9: 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec',
};

const VGPlusTable = ({ auctioncore }) => {
  const { UIStore } = useStores();
  const { isLargeView } = useResponsive();
  const {
    vin, model,
  } = UIStore;

  const [plusReport, setPlusReport] = useState(null);
  const [months, setMonths] = useState(2);
  const [location, setLocation] = useState(null);
  const [soldOnly, setSoldOnly] = useState(false);

  const fetchPlusReport = async () => {
    try {
      const response = await auctioncore.getValueGuidePlus(model, vin, months, location, soldOnly);
      const { valueGuide } = response?.data;
      setPlusReport(valueGuide);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (vin || model) {
      fetchPlusReport();
    }
  }, [vin, model, location, months, soldOnly]);

  if (!plusReport) {
    return null;
  }

  const {
    info, bookValues, conditions, mileages, summaries, times, vehicles,
  } = plusReport;

  return (
    <Container>
      {/* {info.data.vehicleModel && ( */}
      {/* <div> */}
      {/*  <YearMakeTitle> */}
      {/*    {info.data.vehicleYear} */}
      {/*    {' '} */}
      {/*    {info.data.vehicleBrand} */}
      {/*  </YearMakeTitle> */}
      {/*  <YearMakeTitle>{info.data.vehicleModel}</YearMakeTitle> */}
      {/* </div> */}
      {/* )} */}

      <Filters setMonths={setMonths} setLocation={setLocation} setSoldOnly={setSoldOnly} soldOnly={soldOnly} />

      {isLargeView && (
      <SectionWrapper>
        <TableTitle>Vehicle Attributes</TableTitle>
        <AttributesTable>
          <tbody>
            <Tr>
              <Td title>NADA Book</Td>
              <Td title>Units</Td>
              <Td title>Period</Td>
              <Td title>Avg Score</Td>
              <Td title>Avg Mileage</Td>
              <Td title>Avg Sale</Td>
            </Tr>

            <Tr>
              <Td>{bookValues?.data?.bookValue ? `$${formatNumberWithCommas(bookValues?.data?.bookValue)}` : '-'}</Td>
              <Td>{summaries?.data[0]?.numUnits ? summaries?.data[0]?.numUnits : '-'}</Td>
              <Td>
                {info.data.durationMonths ? `${info.data.durationMonths} months` : '-'}
              </Td>
              <Td>{summaries?.data[0]?.avgScore ? summaries?.data[0]?.avgScore : '-'}</Td>
              <Td>{summaries?.data[0]?.avgMilesHours ? formatNumberWithCommas(summaries?.data[0]?.avgMilesHours) : '-'}</Td>
              <Td>
                {summaries?.data[0]?.avgSale ? `$${formatNumberWithCommas(summaries?.data[0]?.avgSale)}` : '--'}
              </Td>
            </Tr>

          </tbody>
        </AttributesTable>
      </SectionWrapper>
      )}

      {!isLargeView && (
      <AttributesTable>
        <tbody>
          {bookValues?.data?.bookValue && (
          <Tr>
            <Td>NADA Book</Td>
            <Td right>
              $
              {formatNumberWithCommas(bookValues?.data?.bookValue)}
            </Td>
          </Tr>
)}
          {summaries?.data[0]?.numUnits && (
          <Tr>
            <Td>Units</Td>
            <Td right>{summaries?.data[0]?.numUnits}</Td>
          </Tr>
          )}

          <Tr>
            <Td>Period</Td>
            <Td right>
              {`${info.data.durationMonths} months`}
            </Td>
          </Tr>

          {summaries?.data[0]?.avgScore && (
          <Tr>
            <Td>Avg Score</Td>
            <Td right>{summaries?.data[0]?.avgScore}</Td>
          </Tr>
          )}

          {summaries?.data[0]?.avgMilesHours && (
          <Tr>
            <Td>Avg Mileage</Td>
            <Td right>{formatNumberWithCommas(summaries?.data[0]?.avgMilesHours)}</Td>
          </Tr>
)}

          {summaries?.data[0]?.avgSale && (
          <Tr>
            <Td>Avg Sale</Td>
            <Td right>
              $
              {formatNumberWithCommas(summaries?.data[0]?.avgSale)}
            </Td>
          </Tr>
          )}

        </tbody>
      </AttributesTable>
      )}
      {conditions && isLargeView && (
      <SectionWrapper>
        <TableTitle>Condition Breakdown</TableTitle>

        {conditions.data.length < 1 && <p>No values found</p>}

        <Table>
          <tbody>
            <Tr>
              <Td title>Condition</Td>
              <Td title>Units</Td>
              <Td title>Avg Score</Td>
              <Td title>Score Range</Td>
              <Td title>Avg Value</Td>
              <Td title>Value Range</Td>
            </Tr>
            {conditions.data.map((item) => (
              <Tr>
                <Td>{`${item.grade} - ${item.grade + 10}`}</Td>
                <Td>
                  {item.numUnits}
                </Td>
                <Td>{item.avgScore}</Td>
                <Td>
                  {`${item.minScore} - ${item.maxScore}`}
                </Td>
                <Td>
                  {`$${formatNumberWithCommas(item.avgSale)}`}
                </Td>
                <Td>
                  {`$${formatNumberWithCommas(item.minSale)} - $${formatNumberWithCommas(item.maxSale)}`}
                </Td>
              </Tr>
            ))}
          </tbody>
        </Table>

      </SectionWrapper>
      )}

      {conditions && !isLargeView && (
      <SectionWrapper>
        <TableTitle>Condition Breakdown</TableTitle>

        {conditions.data.length < 1 && <p>No values found</p>}

        {conditions.data.map((item) => (
          <Table>
            <tbody>
              <Tr>
                <Td title>{`Grade: ${item.grade} - ${item.grade + 10}`}</Td>
                <Td right title>
                  {item.numUnits}
                  {' '}
                  units
                </Td>
              </Tr>

              <Tr>
                <Td>Score Range:</Td>
                <Td right>
                  {`${item.minScore} - ${item.maxScore}`}
                </Td>
              </Tr>

              <Tr>
                <Td>Average Value:</Td>
                <Td right>
                  {`$${formatNumberWithCommas(item.avgSale)}`}
                </Td>
              </Tr>

              <Tr>
                <Td>Value Range:</Td>
                <Td right>
                  {`$${formatNumberWithCommas(item.minSale)} - $${formatNumberWithCommas(item.maxSale)}`}
                </Td>
              </Tr>
            </tbody>
          </Table>
        ))}
      </SectionWrapper>
      )}

      {mileages && isLargeView && (
      <SectionWrapper>
        <TableTitle>Mileage Breakdown</TableTitle>

        {mileages.data.length < 1 && <p>No values found</p>}

        <Table>
          <tbody>
            <Tr>
              <Td title>Condition</Td>
              <Td title>0-7500</Td>
              <Td title>7500-15000</Td>
              <Td title>15000-25000</Td>
              <Td title>25000-40000</Td>
              <Td title>40000+</Td>
            </Tr>
            {mileages.data.map((item) => (
              <Tr>
                <Td>
                  {`${item.grade}-${item.grade + 10}`}
                </Td>
                <Td>
                  {/* {`${item.mH1} asdf`} */}
                  {item.mH1}
                </Td>
                <Td>
                  {item.mH2}
                </Td>
                <Td>
                  {item.mH3}
                </Td>
                <Td>
                  {item.mH4}
                </Td>
                <Td>
                  {item.mH5}
                </Td>
              </Tr>
            ))}
          </tbody>
        </Table>

      </SectionWrapper>
      )}

      {mileages && !isLargeView && (
      <SectionWrapper>
        <TableTitle>Mileage Breakdown</TableTitle>

        {mileages.data.length < 1 && <p>No values found</p>}
        {mileages.data.map((item) => (
          <Table>
            <tbody>
              <Tr>
                <Td title>
                  {`Score ${item.grade}`}

                </Td>
                <Td title right>
                  {item.numUnits}
                  {' '}
                  units
                </Td>
              </Tr>
              {item.mH1 && (
              <Tr>
                <Td>0-7499</Td>
                <Td right>
                  {`${item.mH1}`}
                </Td>
              </Tr>
              )}

              {item.mH2 && (
              <Tr>
                <Td>7500-14999</Td>
                <Td right>
                  {`${item.mH2}`}
                </Td>
              </Tr>
              )}

              {item.mH3 && (
              <Tr>
                <Td>15000-24999</Td>
                <Td right>
                  {`${item.mH3}`}
                </Td>
              </Tr>
              )}

              {item.mH4 && (
              <Tr>
                <Td>25000-39999</Td>
                <Td right>
                  {`${item.mH4}`}
                </Td>
              </Tr>
              )}

              {item.mH5 && (
              <Tr>
                <Td>40000+</Td>
                <Td right>
                  {`${item.mH5}`}
                </Td>
              </Tr>
              )}
            </tbody>
          </Table>
        ))}
      </SectionWrapper>
      )}

      {times && isLargeView && (
      <SectionWrapper>
        <TableTitle>Time Breakdown</TableTitle>
        {times.data.length < 1 && <p>No values found</p>}

        <Table>
          <tbody>
            <Tr>
              <Td title>Month</Td>
              <Td title>Mileage Range</Td>
              <Td title>Units</Td>
              <Td title>Score Range</Td>
              <Td title>Avg. Value</Td>
              <Td title>Value Range</Td>
            </Tr>
            {times.data.map((item) => (
              <Tr>
                <Td>{Months[item.saleMonth]}</Td>
                <Td>{`${item.minMilesHours && formatNumberWithCommas(item.minMilesHours)}-${item.maxMilesHours && formatNumberWithCommas(item.maxMilesHours)}`}</Td>
                <Td>
                  {item.numUnits}
                </Td>
                <Td>{`${item.minScore} - ${item.maxScore}`}</Td>
                <Td>{`$${formatNumberWithCommas(item.avgSale)}`}</Td>
                <Td>
                  {`$${formatNumberWithCommas(item.minSale)}-$${formatNumberWithCommas(item.maxSale)}`}
                </Td>
              </Tr>
            ))}
          </tbody>
        </Table>
      </SectionWrapper>
      )}

      {times && !isLargeView && (
      <SectionWrapper>
        <TableTitle>Time Breakdown</TableTitle>
        {times.data.length < 1 && <p>No values found</p>}
        {times.data.map((item) => (
          <Table>
            <tbody>
              <Tr>
                <Td title>{Months[item.saleMonth]}</Td>
                <Td right title>
                  {item.numUnits}
                  {' '}
                  units
                </Td>
              </Tr>
              <Tr>
                <Td>Score Range:</Td>
                <Td right>
                  {`${item.minScore} - ${item.maxScore}`}
                </Td>
              </Tr>

              <Tr>
                <Td>Value Range:</Td>
                <Td right>
                  {`$${formatNumberWithCommas(item.minSale)} - $${formatNumberWithCommas(item.maxSale)}`}
                </Td>
              </Tr>

              <Tr>
                <Td>Avg Value:</Td>
                <Td right>
                  {`$${formatNumberWithCommas(item.avgSale)}`}
                </Td>
              </Tr>
            </tbody>
          </Table>
        ))}
      </SectionWrapper>
      )}
    </Container>
  );
};

VGPlusTable.propTypes = {
  auctioncore: PropTypes.object.isRequired,
};

export default withAuctionCore(VGPlusTable);
